<div class="buildings-accordions">
    @if (buildingstables?.length > 0) {
    <div class="column-100">
        @for (building of buildingstables; track $index; let i = $index) {
        <div class="tinyinfo-container component-accordion">
            <div class="header" [class.expanded]="building.expanded" (click)="building.expanded = !building.expanded">
                <div class="header-info">
                    <div class="column-50 section sale-type-icon" [ngClass]="{ ukjent: building.buildingInfo.isExistingBuilding, annet: !building.buildingInfo.isExistingBuilding }">
                        <div class="overflow-hide">
                            <div class="strong">BYGNING</div>
                            <div class="info">{{ building.header !== "" ? building.header : "Ukjent" }}</div>
                        </div>
                    </div>
                    <div class="column-50 section space desktop-view">
                        <div class="smaller">
                            <div class="strong">STATUS</div>
                            <div class="info">
                                {{ building.buildingInfo.buildingStatus | defaultconvert }}
                            </div>
                        </div>
                        <div class="smaller">
                            <div class="strong">TATT I BRUK</div>
                            <div class="info">
                                    {{ building.buildingInfo.buildingAppliedDate | date:'dd.MM.yyyy' | defaultconvert }}
                            </div>
                        </div>
                        <div class="smaller">
                            <div class="strong">BRA</div>
                            <div class="info">
                                {{ building.buildingInfo.usableArea | areaconverter }}
                            </div>
                        </div>
                         <div class="icon-pannel">
                            @if (building.changes.length > 0) {
                                <span title="Endringer" class="short-info">E</span>
                                <span title="Endringer" class="counter" [ngClass]="{ expanded: building.expanded }">
                                    {{ building.changes.length }}
                                </span>
                            }
                            @if (building.usageUnits.length > 0) {
                                <span title="Bruksenheter" class="short-info">B</span>
                                <span title="Bruksenheter" class="counter" [ngClass]="{ expanded: building.expanded }">
                                    {{ building.usageUnits.length }}
                                </span>
                            }
                        </div> 
                    </div>
                </div>
                <ev-expanded-icon [expanded]="building.expanded" [size]="22"></ev-expanded-icon>
            </div>
            <div class="content-build" [class.expanded]="building.expanded">
                <div class="table">
                    <div class="building-info-main-wrapper">
                        <div class="left-side">
                            <div class="building-info-wrapper">
                                <div class="keyvalue-pair">
                                    <div>Bygningstype</div>
                                    <div>{{ building.buildingInfo.buildingType }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Bygningsstatus</div>
                                    <div>{{ building.buildingInfo.buildingStatus }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Næringsgruppe</div>
                                    <div>{{ building.buildingInfo.buildingPurpose }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Påbygg/tilbygg</div>
                                    <div>{{ building.buildingInfo.extensionType }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Antall etasjer</div>
                                    <div>{{ building.buildingInfo.numFloors }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Antall boliger</div>
                                    <div>{{ building.buildingInfo.numFunctionalUnits }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Vannforsyning</div>
                                    <div>{{ building.buildingInfo.waterSupply }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Oppvarming</div>
                                    <div>{{ building.buildingInfo.heating }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Antall bad</div>
                                    <div>{{ building.buildingInfo.numBathrooms }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Antall WC</div>
                                    <div>{{ building.buildingInfo.numWCs }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="right-side">
                            <div class="building-info-wrapper">
                                @if (building.buildingInfo.bREEMCertificateRating) {
                                    <div class="keyvalue-pair">
                                        <div>
                                            <div>BREEAM</div>
                                            <div>{{ building.buildingInfo.bREEMCertificateRating }}</div>
                                        </div>
                                        <div class="breeam-icon-wrapper">
                                            @for (item of breeamArray; track $index; let last = $last; let index = $index) {
                                                <div
                                                    class="bream-icon"
                                                    [ngClass]="{ last: last, active: index + 1 <= building.buildingInfo.bREEMCertificateRatingID }"
                                                ></div>
                                            }
                                        </div>
                                    </div>
                                }

                                <div class="keyvalue-pair">
                                    <div>Godkjent dato</div>
                                        <div>{{ building.buildingInfo.applicationApprovedDate | date:'dd.MM.yyyy' }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Igangsatt dato</div>
                                        <div>{{ building.buildingInfo.constructionStartDate | date:'dd.MM.yyyy' }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Tatt i bruk dato</div>
                                        <div>{{ building.buildingInfo.buildingAppliedDate | date:'dd.MM.yyyy' }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Bruksareal totalt</div>
                                    <div>{{ building.buildingInfo.usableArea | areaconverter }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Primært bruksareal</div>
                                    <div>{{ building.buildingInfo.primaryUsableArea | areaconverter }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Bruksareal bolig</div>
                                    <div>{{ building.buildingInfo.residentialUsableArea | areaconverter }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Bruksareal annet</div>
                                    <div>{{ building.buildingInfo.otherUsableArea | areaconverter }}</div>
                                </div>
                                <div class="keyvalue-pair">
                                    <div>Bygningsnummer</div>
                                    <div>{{ building.buildingInfo.buildingNumber }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                @if (building.changes && building.changes.length > 0) {
                    <sub-group
                        [showExpandedBorder]="true"
                        headerText="Endringer"
                        [infoText]="'' + building.changes.length"
                    >
                        @for (change of building.changes; track change) {
                            <div class="sub-entry">
                                <building-change [buildingChange]="change"></building-change>
                            </div>
                        }
                    </sub-group>
                }

                <sub-group headerText="Bruksenheter" [infoText]="'' + building.usageUnits.length" (onExpanded)="onUnitTableExpanded($event, i)">
                    <units-table [usageUnits]="building.usageUnits" [maxToShow]="initmaxToShowUnitTableValues[i]"></units-table>
                </sub-group>
            </div>
        </div>
        }
    </div>
    }
    <ev-seemore-button
        [(currentNumItems)]="_currentToShow"
        (currentNumItemsChange)="onSeeMoreClicked()"
        [maxItems]="buildings.length"
        [steps]="seeMoreSteps">
    </ev-seemore-button>
</div>

